import React from "react";
import { Route, Routes } from "react-router-dom";
import LoggedOut from "../pages/LoggedOut";
import SignInGateway from "../pages/auth/SignInGateway";

function UnAuthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<SignInGateway view="signIn" />} />
      <Route path="/signup" element={<SignInGateway view="signUp" />} />
      <Route path="/reset-password" element={<SignInGateway view="resetPassword" />} />
      <Route path="/logged-out" element={<LoggedOut />} />
      <Route path="/*" element={<SignInGateway view="signIn" />}></Route>
    </Routes>
  );
}

export default UnAuthenticatedRoutes;
